import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import Modal from 'shared/components/common/Modal/Modal.component'
import { createDivAtom } from 'shared/atoms/factory'
import Button from 'shared/components/common/Button/Button.component'
import * as Actions from 'state/actions'

import styles from './DeleteExportItemModal.module.scss'

import deleteIcon from 'shared/assets/icons/delete.svg'

const Wrapper = createDivAtom(),
      Body = createDivAtom(),
      ButtonWrapper = createDivAtom()

const DeleteExportItemModal = (props) => {
  const { exportId } = props

  const [ isOpen, updateModal ] = useState(false)
  const toggleModal = () => updateModal(!isOpen)

  const dispatch = useDispatch()

  return (
    <>
      <img className={styles.exportItemDeleteButton} src={deleteIcon} onClick={toggleModal} />

      <Modal
        isOpen={isOpen}
        onClose={toggleModal}
        size='medium'
      >
        <Wrapper className={styles.wrapper}>
          <Body className={styles.body}>
            Deleting is irreversible. Confirm that you want to permanently delete it.
          </Body>

          <ButtonWrapper className={styles.buttonWrapper}>
            <Button
              className={styles.buttonBody}
              onClick={() => {
                dispatch(Actions.deleteExportItem(exportId))
                toggleModal()
              }}
              title='Delete'
            />
            <Button
              primary
              className={styles.buttonBody}
              onClick={toggleModal}
              title='Cancel'
            />
          </ButtonWrapper>
        </Wrapper>
      </Modal>
    </>
  )
}

DeleteExportItemModal.propTypes ={
  exportId: PropTypes.string
}

export default DeleteExportItemModal